import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

import { Col, Dropdown } from "react-bootstrap";
import { PROPERTIES } from "../../../constants/report"

import {
  getConditionsForProperty,
  getDefaultConditionForProperty,
  getPropertyByKey,
} from "../../../services/report.service";
import { guid } from "../../../services/utils"
import Truncate from "src/components/truncate";
import AsyncSelect from "react-select/async";

import {
  searchStreams,
  searchUserGroupForAutoComplete,
  searchCollections,
  searchAsset,
  searchContacts,
  searchUsers,
  searchCompanies,
} from "../../../redux/actions/search"

import { searchUserRolesForAutoComplete } from "../../../redux/actions/userRoles"

import userRoleService from "src/services/userRoles.service";
import ReportDatePicker from "./datepicker";
import { Button } from "react-bootstrap";
import DOMPurify from "dompurify";

import cx from "classnames";
import styles from '../reports.module.scss';

import { localizedStrings } from "../../../../localization"

export default class ReportFiltersView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editor: false,
    };

    this.handleReportDateChange = this.handleReportDateChange.bind(this);
    this.localizedFilters = localizedStrings.pages.reports.filters;
  }

  handleReportDateChange(value) {
    const filter = this.props.value;

    this.props.onChange({
      ...filter,
      reportDate: value,
    });
  }

  render() {
    return (
      <div className={styles.reportFilters}>
        <ReportDatePicker
          value={this.props.value.reportDate}
          onChange={this.handleReportDateChange}
          filter={this.props.value}
          handleTimeLineChange={this.props.handleTimeLineChange}
        />

        <Dropdown.Toggle className={styles.action} onClick={() => {
          this.setState({
            editor: !this.state.editor,
          });
        }}>
          {this.localizedFilters.entity.any_entity} <span className={styles.arrow}>
            <i className='paperflite-dropdown' />
          </span>
        </Dropdown.Toggle>

        <FilterEditor
          show={this.state.editor}
          filters={this.props.value.filters}
          onChange={this.props.onChange}
        />
      </div>
    );
  }
}

class FilterEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.handleAddFilter = this.handleAddFilter.bind(this);
    this.handleChangeFilter = this.handleChangeFilter.bind(this);
    this.handleDeleteFilter = this.handleDeleteFilter.bind(this);
  }

  handleAddFilter(filter, index) {
    if (!filter) {
      return;
    }

    var filters = this.props.filters || [];
    filters.splice(index, 0, filter);
    this.props.onChange(filters);
  }

  handleChangeFilter(filter) {
    if (!filter) {
      return;
    }

    var filters = (this.props.filters || []).map((item) => {
      if (item._id === filter._id) {
        return filter;
      }

      return item;
    });

    this.props.onChange({
      filters: filters,
    });
  }

  handleDeleteFilter(filter) {
    if (!filter) {
      return;
    }

    var filters = (this.props.filters || []).filter((item) => {
      return item._id != filter._id;
    });

    this.props.onChange({
      filters: filters,
    });
  }

  render() {
    const empty = (this.props.filters || []).length === 0;

    return (
      <div
        className={cx(styles.filterEditor, {
          [styles.show]: this.props.show,
        })}
      >
        <div className={styles.inner}>
          {(this.props.filters || []).map((filter, index) => (
            <FilterRow
              key={filter._id}
              index={index}
              value={filter}
              onAdd={this.handleAddFilter}
              onChange={this.handleChangeFilter}
              onDelete={this.handleDeleteFilter}
            />
          ))}

          {empty && (
            <FilterRow
              key={`empty`}
              onAdd={this.handleAddFilter}
              onChange={this.handleChangeFilter}
              onDelete={this.handleDeleteFilter}
            />
          )}
        </div>
      </div>
    );
  }
}

/**
 * Filter Row Implementation
 */
class FilterRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openPropertyDropdown: false,
      openConditionDropdown: false,
      showConditionFilter: false,
    };

    this.handlePropertyTypeChange = this.handlePropertyTypeChange.bind(this);
    this.handleConditionChange = this.handleConditionChange.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);

    this.handleAddFilter = this.handleAddFilter.bind(this);
    this.handleDeleteFilter = this.handleDeleteFilter.bind(this);
  }

  handlePropertyTypeChange(item) {
    const property = { type: item };

    if (!this.props.value) {
      this.props.onAdd(
        {
          _id: guid(),
          property: property,
          operator: getDefaultConditionForProperty(property),
          value: [],
        },
        0
      );

      return;
    }

    if (_.get(this.props.value, "property.type") === item) {
      return;
    }

    const filter = {
      ...this.props.value,
      property: property,
      operator: getDefaultConditionForProperty(property),
      value: [],
    };

    this.props.onChange(filter);
  }

  handleConditionChange(value) {
    if (!this.props.value) {
      return;
    }

    const filter = {
      ...this.props.value,
      operator: value,
      value:
        this.props.value.operator === "has_role" ? [] : this.props.value.value,
    };

    this.props.onChange(filter);
  }

  handleValueChange(value) {
    if (!this.props.value) {
      return;
    }

    const filter = {
      ...this.props.value,
      value: value,
    };

    this.props.onChange(filter);
  }

  handleAddFilter(index) {
    const property = PROPERTIES[0];
    const filter = {
      _id: guid(),
      property: property,
      operator: getDefaultConditionForProperty(property),
      value: [],
    };

    this.props.onAdd(filter, index + 1);
  }

  handleDeleteFilter() {
    if (!this.props.value) {
      return;
    }
    this.props.onDelete(this.props.value);
  }

  render() {
    return (
      <div className={cx(styles.filterRow)}>
        <PropertyTypeFilter
          value={this.props.value}
          onChange={this.handlePropertyTypeChange}
        />
        {this.props.value && [
          <ConditionFilter
            key="condition"
            value={this.props.value}
            onChange={this.handleConditionChange}
          />,
          <ValueComponent
            key="value"
            value={this.props.value}
            onChange={this.handleValueChange}
          />,
          <div key="actions" className={styles.actions}>
            <span
              className={styles.addButton}
              onClick={() => this.handleAddFilter(this.props.index)}
            >
              <i className="paperflite-add"></i>

            </span >
            <span className={styles.deleteButton} onClick={this.handleDeleteFilter}>
              <i className="paperflite-close"></i>

            </span>
          </div>,
        ]}
      </div>
    );
  }
}

/*
 * Filter Actions
 */

/*
  Property Type Filter
*/
class PropertyTypeFilter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.localizedFilters = localizedStrings.pages.reports.filters;

  }

  handleChange(key) {
    const selectedOption = PROPERTIES.find((property) => {
      return property.type === key;
    });

    if (this.props.onChange) {
      this.props.onChange(selectedOption.type);
    }

    this.setState({
      open: false,
    });
  }

  canAccessEntity(property) {
    const type = property.type;

    switch (type) {
      case 'collection':
        return userRoleService.canAccessCollection();

      case 'contact':
      case 'company':
        return userRoleService.canShare();

      default:
        return true;
    }
  }

  render() {
    var property = this.props.value
      ? getPropertyByKey(PROPERTIES, this.props.value)
      : null;
    var selectedValue = _.get(property, "name");

    return (
      <Dropdown
        id={this.props.filterType}
        // rootCloseEvent="click"
        show={this.state.open}
        className={cx(styles.dropdown, styles.propertyDropdown)}
        onToggle={(isOpen, e) => {
          this.setState({
            open: isOpen,
          });
        }}
      >
        <Dropdown.Toggle className={styles.action}>
          {selectedValue || this.localizedFilters.entity.any_entity} <span className={styles.arrow}>
            <i className='paperflite-dropdown' />
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <div className={styles.options}>
            {PROPERTIES.map((item) => {
              if (this.canAccessEntity(item)) {
                const active = selectedValue === item.name;
                return (
                  <div
                    className={cx(styles.option, {
                      [styles.active]: active
                    })}
                    key={item.type}
                    onClick={() => this.handleChange(item.type)}
                  >
                    {item.name}
                  </div>
                );
              }
            })}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

/*
  Condition Filter
*/
class ConditionFilter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(key) {
    this.props.onChange(key);

    this.setState({
      open: false,
    });
  }

  render() {
    var property = getPropertyByKey(PROPERTIES, this.props.value);
    var conditionOptions = getConditionsForProperty(property).map((option) => {
      return { key: option.key, value: option.key, text: option.text };
    });

    const activeOperator = conditionOptions.find((item) => {
      return item.value == this.props.value.operator;
    });

    return (
      <Dropdown
        id={this.props.filterType}
        // rootCloseEvent="click"
        show={this.state.open}
        className={cx(styles.dropdown, styles.conditionDropdown)}
        onToggle={(isOpen, e) => {
          this.setState({
            open: isOpen,
          });
        }}
      >
        <Dropdown.Toggle className={styles.action}>
          {_.get(activeOperator, "text")} <span className={styles.arrow}>
            <i className='paperflite-dropdown' />
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <div className={styles.options}>
            {conditionOptions.map((item) => {
              const active = this.props.value.operator === item.value;
              return (
                <div
                  key={item.key}
                  className={cx(styles.option, {
                    [styles.active]: active
                  })}
                  onClick={() => this.handleChange(item.key)}
                >
                  {item.text}
                </div>
              );
            })}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

/*
  Value Component
*/
class ValueComponent extends React.Component {
  render() {
    const propertyConfig = getPropertyByKey(PROPERTIES, this.props.value);
    var conditionOptions = getConditionsForProperty(propertyConfig);

    const activeOperator = conditionOptions.find((item) => {
      return item.key == this.props.value.operator;
    });

    if (_.get(activeOperator, "unary")) {
      return <div className={styles.entityValue}></div>;
    }

    var filterType = propertyConfig ? propertyConfig.filter_type : null;
    var type = propertyConfig ? propertyConfig.data_type : null;
    var operator = activeOperator ? activeOperator.text : null;

    const value = _.get(this.props.value, "value") || [];
    if (filterType === "entity_filter") {
      return (
        <EntityValueContainer
          type={type}
          value={value}
          operator={operator}
          onChange={this.props.onChange}
        />
      );
    }
  }
}

/*
  AutoComplete Dropdown
*/
class EntityValue extends React.Component {
  constructor(props) {
    super(props);

    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.getStyles = this.getStyles.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedFilters = localizedStrings.pages.reports.filters;
  }

  handleSearch(query) {
    if (!query || query.trim() === "") {
      return Promise.resolve();
    }

    var options = [];

    return this.props.searchEntity(query).then((data) => {
      options = [...data.options];
      return options;
    });
  }

  handleChange(options) {
    var values = this.props.value || [];

    if (!Array.isArray(options)) {
      options = [options];
    }

    options
      .map((option) => {
        return {
          id: option.value,
          name: option.label,
          optionId: option.id ? option.id : null,
          entityType: this.props.type,
        };
      })
      .forEach((item) => {
        if (!_.includes(values, item)) {
          values = [...values, item];
        }
      });

    this.props.onChange(values);
  }

  handleDelete(value) {
    var values = (this.props.value || []).filter(
      (item) => !_.isEqualWith(item, value, "id")
    );
    this.props.onChange(values);
  }

  getStyles() {
    return {
      control: (base, state) => ({
        ...base,
        minHeight: "1rem",
      }),
      indicatorSeparator: (base, state) => ({
        ...base,
        alignSelf: "auto",
      }),
      dropdownIndicator: (provided) => ({
        ...provided,
        display: "none",
      }),
    };
  }

  render() {
    return (
      <div className={styles.entityValue}>
        {(this.props.value || []).map((value, index) => {
          return (
            <div>
              <Label onDelete={this.handleDelete} value={value} index={index} />
              <span
                className={cx(styles.operator, {
                  [styles.border]: index == this.props.value.length - 1,
                })}
                onClick={(index) => this.handleClick(index)}
              >
                {this.localizedCommons.or}
              </span>
            </div>
          );
        })}

        <AsyncSelect
          className={styles.searchInput}
          autoload={false}
          ref={(ref) => (this.selectRef = ref)}
          isMulti
          placeholder=""
          filterOption={() => {
            return true;
          }}
          value={null}
          styles={this.getStyles()}
          loadOptions={this.handleSearch}
          onChange={this.handleChange}
          loadingMessage={() => `${this.localizedCommons.loading.loading}...`}
          noOptionsMessage={() => `${this.localizedFilters.no_options}`}
        />
      </div>
    );
  }
}

/*
  Filter Label
*/
class Label extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <label className={cx(styles.value)}>
        <span className={styles.truncate}>{this.props.value.name}</span>
        <i
          className={cx("paperflite-close", styles.close)}
          onClick={() => this.props.onDelete(this.props.value)}
        ></i>
      </label>
    );
  }
}

const EntityValueContainer = connect(
  (state, ownProps) => {
    return {};
  },
  (dispatch) => {
    return {
      searchStreams: (query, filter, page, limit, highlight) => {
        return dispatch(searchStreams(query, filter, page, limit, highlight));
      },
      searchUsers: (query, page, limit, ignoreMe) => {
        return dispatch(searchUsers(query, page, limit, ignoreMe));
      },
      searchUserGroupForAutoComplete: (query, showAll) => {
        return dispatch(searchUserGroupForAutoComplete(query, showAll));
      },
      searchCollections: (query, page, limit, highlight) => {
        return dispatch(searchCollections(query, null, page, limit, highlight));
      },
      searchAsset: (query, filter, page, limit, highlight, searchWithinHub) => {
        return dispatch(
          searchAsset(query, filter, page, limit, highlight, searchWithinHub)
        );
      },
      searchContacts: (query, page, limit) => {
        return dispatch(searchContacts(query, true, page, limit, false));
      },
      searchCompanies: (query, page, limit) => {
        return dispatch(searchCompanies(query, page, limit));
      },
      searchUserRolesForAutoComplete: (query) => {
        return dispatch(searchUserRolesForAutoComplete(query));
      },
    };
  },
  (stateProps, dispatchProps, ownProps) => {
    return Object.assign({}, ownProps, {
      ...stateProps,
      ...dispatchProps,
      searchEntity: (query) => {
        const type = ownProps.type;
        const operator = ownProps.operator;

        if (type === "stream") {
          var filter = {
            searchWithinHub: true,
          };

          return dispatchProps
            .searchStreams(query, filter, 0, 12, false)
            .then((data) => {
              const results = _.get(data, "payload.result.records") || [];
              const options = results.map((item) => {
                return {
                  value: item.id,
                  label: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(item.name),
                      }}
                    ></div>
                  ),
                };
              });

              return {
                options: options,
              };
            });
        } else if (type === "user") {
          if (operator === "Has Role") {
            return dispatchProps
              .searchUserRolesForAutoComplete(query)
              .then((data) => {
                const results = _.get(data, "payload") || [];
                const options = results.map((item) => {
                  return {
                    value: item.key,
                    label: item.name,
                    id: item.id,
                  };
                });

                return {
                  options: options,
                };
              });
          } else {
            return dispatchProps
              .searchUsers(query, 0, 12, false)
              .then((data) => {
                const results = _.get(data, "payload.result.records") || [];
                const options = results.map((item) => {
                  return {
                    value: item.id,
                    label: `${_.get(item, "firstName") || ""} ${_.get(item, "lastName") || ""
                      }`,
                  };
                });

                return {
                  options: options,
                };
              });
          }
        } else if (type === "user_group") {
          return dispatchProps
            .searchUserGroupForAutoComplete(
              query,
              !userRoleService.canRestrictAllReports()
            )
            .then((data) => {
              const results = _.get(data, "payload.records") || [];
              const options = results.map((item) => {
                return {
                  value: item.id,
                  label: item.name,
                };
              });

              return {
                options: options,
              };
            });
        } else if (type === "collection") {
          return dispatchProps
            .searchCollections(query, 0, 12, false)
            .then((data) => {
              const results = _.get(data, "payload.result.records") || [];
              const options = results.map((item) => {
                return {
                  value: item.id,
                  label: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(item.name),
                      }}
                    ></div>
                  ),
                };
              });

              return {
                options: options,
              };
            });
        } else if (type === "asset") {
          return dispatchProps
            .searchAsset(query, null, 0, 15, true, false)
            .then((data) => {
              const results = _.get(data, "payload.result.records") || [];
              const options = results.map((item) => {
                return {
                  value: item.id,
                  label: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(item.name),
                      }}
                    ></div>
                  ),
                };
              });

              return {
                options: options,
              };
            });
        } else if (type === "contact") {
          return dispatchProps.searchContacts(query, 0, 12).then((data) => {
            const results = _.get(data, "payload.result.records") || [];
            const options = results.map((item) => {
              return {
                value: item.id,
                label: (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        `${_.get(item, "email") || ""}`
                      ),
                    }}
                  ></div>
                ),
              };
            });

            return {
              options: options,
            };
          });
        } else if (type === "company") {
          return dispatchProps.searchCompanies(query, 0, 12).then((data) => {
            const results = _.get(data, "payload.result.records") || [];
            const options = results.map((item) => {
              return {
                value: item.name,
                label: (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        `${_.get(item, "name") || ""}`
                      ),
                    }}
                  ></div>
                ),
              };
            });

            return {
              options: options,
            };
          });
        }
      },
    });
  }
)(EntityValue);
